/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>6 - Абсолютные и относительные пути</h2>
    <p className={styles.description}>
      Веб-сайты содержат множество документов, которые размещают в отдельные папки, чтобы ими было легче управлять.
      Чтобы создать ссылку на файл, находящийся вне папки, содержащей текущий документ, необходимо указать расположение
      файла или путь. Существует два вида путей к файлам и папкам.
    </p>

    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.1 - Абсолютный путь</h3>
      <p className={styles.description}>
        Указывает точное местоположение файла в структуре папок в проекте или на сервере. Абсолютный путь к файлу
        позволяет получить доступ к файлу со сторонних ресурсов и выглядит следующим образом:{' '}
        <a
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://images.pexels.com/photos/583842/pexels-photo-583842.jpeg"
        >
          https://images.pexels.com/photos/583842/pexels-photo-583842.jpeg
        </a>
      </p>
    </section>

    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.2 - Относительный путь</h3>
      <p className={styles.description}>
        Описывает путь к указанному документу относительно текущего. Относительные ссылки используются при создании
        ссылок на другие документы на одном и том же сайте. Когда браузер не находит в ссылке протокол, он выполняет
        поиск указанного документа на том же сервере. Относительный путь состоит из имени папки, указывающей путь к
        файлу, и имени самого файла.
      </p>
      <p className={styles.description}>
        Для составления пути относительных ссылок есть несколько специальных обозначений:
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>/</code> - указывает на корневую папку, к примеру
          <code className={styles.code}>/img/smile.png</code>
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>./</code> - указывает на текущую папку, к примеру
          <code className={styles.code}>./img/smile.png</code>
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>../</code> - подняться на одну папку выше, к примеру
          <code className={styles.code}>../img/smile.png</code>
        </li>
      </ul>
      <p className={styles.description}>
        <a
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.uamedwed.com/blog/web/absolyutnyj-i-otnositelnyj-put-k-fajlam.html"
        >
          Статья к прочтению
        </a>
      </p>
      <p className={styles.notificationWarn}>
        Когда в пути указывается только имя файла, браузер предполагает, что файл находится в той же папке, что и
        документ, содержащий ссылку.
      </p>
    </section>
  </section>
))
